import React, {Component} from 'react';
import {Control, Errors, actions} from 'react-redux-form';
import {FormGroup, ControlLabel} from 'react-bootstrap';
import Select from 'react-select';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import {validators} from '../../../utils/validators';
import PropTypes from 'prop-types';

class ContactUsSelect extends Component {
    constructor(props){
        super(props);

        this.state = {};
    }

    updateErrors = (field, value) => {
        this.setState({
            [field]: value
        });
    };

    createLabel = (item) => {
        const {labelAttr} = this.props;
        let finalLabel = [];
        labelAttr.map(label => {
            finalLabel.push(get(item, label))
        });
        return finalLabel.join(' ');
    };

    renderOptions = (values) => {
        const {valueAttr} = this.props;
        let options = [];
        if(isPlainObject(values)){
            options = (
                Object.keys(values).map(item => {
                    return { value: item, label:  values[item]};
                })
            )
        } else {
            options = (
                values.map(item => {
                    if(isPlainObject(item)){
                        return { value: get(item, valueAttr), label: this.createLabel(item) };
                    } else {
                        return { value: item, label: item };
                    }
                })
            )
        }
        options.unshift({ value: '', label: 'Select one...'});
        return options;
    };

    changeAction = (model, value) => {
        return (dispatch) => {
            dispatch(actions.change(model, value.value));
            dispatch(actions.resetValidity(model));
            if(typeof this.props.onChange === 'function') {
                this.props.onChange(value.value);
            }
        };
    };

    render(){
        const {model, values, label, controlId, errorLabel} = this.props;
        return (
            <FormGroup controlId={controlId} validationState={this.state[errorLabel]}>
                {label && <ControlLabel>{label}*</ControlLabel>}
                <Control.select
                    model={model}
                    validators={{required: validators.required(this.updateErrors, errorLabel)}}
                    component={Select}
                    options={this.renderOptions(values)}
                    clearable={false}
                    searchable={false}
                    changeAction={this.changeAction}>
                </Control.select>

                <Errors
                    show={{touched: true, focus: false}}
                    className="errors"
                    model={model}
                    messages={{required: 'This field is required'}}/>
            </FormGroup>
        )
    }
}

ContactUsSelect.propTypes = {
    model: PropTypes.string.isRequired,
    label: PropTypes.string,
    values: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object]).isRequired,
    labelAttr: PropTypes.array,
    valueAttr: PropTypes.string,
    hasEmptyValue: PropTypes.bool,
    controlId: PropTypes.string,
    errorLabel: PropTypes.string,
};

ContactUsSelect.defaultProps = {
    hasEmptyValue: true,
    labelAttr: 'label',
    valueAttr: 'value',
    controlId: Math.random().toString(16).substring(2),
    errorLabel: 'error',
};

export default ContactUsSelect;


// WEBPACK FOOTER //
// ./src/components/contact-us/post-login/contact-us-select.jsx